import { translate } from '../i18n';

const asset = (path) => `${process.env.PUBLIC_URL || ''}${path}`;

export const PARTNER_WHATSAPP_NUMBER = '212691154252';

/**
 * Partner offer slides shown on the dashboard.
 * Add a new object here to introduce another partner — the banner
 * layout, WhatsApp CTA, and autoplay stay the same.
 */
export const PARTNER_OFFERS = [
  {
    id: 'yourtech',
    name: 'YourTech',
    website: 'https://www.yourtech.ma/',
    logo: asset('/partners/yourtech-logo.png'),
    logoClassName: 'max-h-10 md:max-h-12 max-w-[148px]',
    products: asset('/partners/yourtech-products.jpg'),
    badge: 'Exclusive partner offer',
    headline: 'Creator gear perks available',
    subhead: 'Message us to unlock your partner code',
    detail: 'For cameras, mics, phones and creator accessories.',
    cta: 'Get access',
    whatsappMessage:
      "Hi! I'm an ArabCap creator and I'd like the YourTech partner code for creator gear.",
  },
  {
    id: 'winashop',
    name: 'Wina Shop',
    website: 'https://winashop.com/',
    logo: asset('/partners/winashop-logo.jpg'),
    logoClassName: 'max-h-16 md:max-h-[76px] max-w-[96px] md:max-w-[110px]',
    products: asset('/partners/winashop-products.jpg'),
    badge: 'Exclusive partner offer',
    headline: 'Cinema gear perks available',
    subhead: 'Message us to unlock your partner code',
    detail: 'For cinema cameras, lenses, lighting and studio gear.',
    cta: 'Get access',
    whatsappMessage:
      "Hi! I'm an ArabCap creator and I'd like the Wina Shop partner code for camera and video gear.",
  },
];

export const getPartnerWhatsAppUrl = (offer) =>
  `https://wa.me/${PARTNER_WHATSAPP_NUMBER}?text=${encodeURIComponent(translate(offer.whatsappMessage))}`;
